/*
 * @Description: '个人中心'页面所有路由
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-26 16:48:59
*/

export default [
    {
        path: '/user',
        component: resolve => require(['@/views/user'], resolve),
        name: 'user',
        meta: {
            nav: '个人中心'
        }
    },
    {
        path: '/notify/:id',
        component: resolve => require(['@/views/user/notify'], resolve),
        name: 'notify',
        meta: {
            nav: '通知设置'
        }
    },
    {
        path: '/calculator',
        component: resolve => require(['@/views/user/calculator'], resolve),
        name: 'calculator',
        meta: {
            nav: '收益计算器'
        }
    },
    // {
    //     path: '/incomeComparison',
    //     component: resolve => require(['@/views/user/incomeComparison'], resolve),
    //     name: 'incomeComparison',
    //     meta: {
    //         nav: '补贴活动'
    //     }
    // },
]



// WEBPACK FOOTER //
// ./src/router/user.js